"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_leaflet_1 = require("react-leaflet");
var MapBoundsHandler = function (_a) {
    var bounds = _a.bounds, center = _a.center, children = _a.children;
    var map = react_leaflet_1.useLeaflet().map;
    react_1.useEffect(function () {
        if (map) {
            if (center) {
                map.setView.call(map, { lat: center.latitude, lng: center.longitude }, 16);
            }
            else {
                map.fitBounds.call(map, bounds);
            }
        }
    }, [map, bounds, center]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
MapBoundsHandler.displayName = 'MapBoundsHandler';
exports.default = MapBoundsHandler;
